import * as M from 'shared/types/models';

export function includesElement(n: number, range: M.Range): boolean {
  return n >= range.start && n <= range.end;
}
